
import WDModal from './wd-modal'
import WDPanes from '../pane/wd-panes'

export default class WDModalPanes extends WDModal {

  #panes = null;

  constructor(opts)
  {
    super(opts).classList.add('wd-modal-panes');

    this.on('modal:show',() => {
      this.hideFooter();
    });
  };
  
  get panes()
  {
    if (!this.#panes)
    {
      this.#panes = new WDPanes({inModal:true});
      this.body.append(this.#panes);
    }
    
    return this.#panes;
  };

  get currentPane()
  {
    return this.panes.currentPane;
  };

  cleanupCallback()
  {
    // Call parent cleanup FIRST
    super.cleanupCallback();
    
    // Clean up panes
    this.#panes = null;
  }

};

customElements.define('wd-modal-panes',WDModalPanes);